import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { AppRoutes } from '../../enums/Approutes';

const BillingSuccess: React.FC = () => {
    const navigate = useNavigate();

    const handleBackToBilling = () => {
        if (window.opener && !window.opener.closed) {
            window.close();
        } else {
            navigate(AppRoutes.BILLING);
            window.close();
        }
    };

    return (
        <div className='max-h-screen w-full px-4 py-8 md:px-[23%] md:py-14'>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    textAlign: 'center'
                }}
            >
                <CheckCircleIcon
                    sx={{
                        fontSize: 80,
                        color: '#4CAF50',
                        mb: 3
                    }}
                />
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
                    Pagamento Completato!
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, color: '#666' }}>
                    I tuoi crediti sono stati aggiunti al tuo account. Riceverai una email di conferma.
                </Typography>
                <Button
                    variant="contained"
                    onClick={handleBackToBilling}
                    sx={{
                        backgroundColor: '#E9495A',
                        '&:hover': { backgroundColor: '#E6263B' },
                        px: 4,
                        py: 1.5
                    }}
                >
                    Torna al Billing
                </Button>
            </Box>
        </div>
    );
};

export default BillingSuccess;